<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h4>Slet: {{ DbTemplate.name }}</h4> <span class="fw-bold">Id: [{{ DbTemplate.id }}]</span>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-body col-12">
    <div class="row">
        @if(isLoading)
        {
            <div class="d-flex flex-column justify-content-center align-items-center w-100">
                <div class="continuous-loader" role="status"></div>
                <h4 class="mt-2">{{ loadingText }}</h4>
            </div>
        }
        @else 
        {
            @if (templateUsedIn.length > 0)
            {
                <span class="fw-bold">Skabelon bruges hos:</span>
                <div class="table-wrap-25vh mt-2">
                    <table class="table table-hover table-striped">
                        <thead class="thead-sticky">
                            <tr>
                                <th scope="col"> Afdeling </th>
                                <th scope="col"> Skabelonnavn [id]</th>
                                <th scope="col"> Aktiv</th>
                                <th scope="col"> </th>
                            </tr>
                        </thead>    
                        <tbody>
                            @for (item of templateUsedIn; track $index)
                            {
                                <tr>
                                    <td>{{ item.departmentName }}</td>
                                    <td>{{ item.templateName }} [{{item.templateId}}]</td>
                                    <td>{{ item.templateEnabled ? 'Ja' : 'Nej' }} <span [ngClass]="item.templateEnabled ? 'fa-solid fa-triangle-exclamation fa-fade' : ''"></span></td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }
        }
    </div>

    <div class="modal-footer bg-transparent">
        <button class="btn btn-danger float-end" (click)="onDelete()">Slet</button>
    </div>
</div>